
  import '/Users/jilin/projects/antd/rc-dialog/docs/demo/pure.md?watch=parent';
  export const texts = [];
  